import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { SharedModule } from 'app/shared/shared.module';
import { MiniappsService } from './miniapps.service';
import { Observable, tap } from 'rxjs';
import { AppState } from 'app/shared/common/utils/AppState';
import { environment } from 'environments/environment';
import { UtilCommon } from 'app/shared/common/utils/UtilCommon';

@UntilDestroy()
@Component({
    selector: 'miniapps',
    standalone: true,
    imports: [
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        SharedModule
    ],
    templateUrl: './miniapps.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'miniapps'
})
export class MiniappsComponent implements OnInit {
    availableMiniapps: any[] = [];
    miniAppId: string;
    flagCodes: any;
    isFirstEnter: boolean = true;

    /**
     * Constructor
     */
    constructor(
        private _service: MiniappsService,
        private _changeRef: ChangeDetectorRef,
        private _appState: AppState
    ) {
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    /**
     * On init
     */
    async ngOnInit(): Promise<void> {
        this.availableMiniapps = await this._service.getMiniApps();
        if (!this.miniAppId) {
            this.miniAppId = this.availableMiniapps[0]?.id;
            this._changeRef.detectChanges();
        }
    }

    changeMiniApps(activeLang) {
        // this.miniAppId = activeLang?.id;
        this._callAPISwitchApp().pipe(tap(item=> {
        //    console.log(item);
        })).subscribe(item=> {
            if(item) {
                const token = item?.id_token;
                const url = `${environment.switchXcore}?token=${token}`;
                UtilCommon.windowOpenUrl(url);
            }
        })
    }

    private _callAPISwitchApp(): Observable<any>{
        const userInfo = this._appState.getAppState();
        const payload = {
            username: userInfo?.username,
            rememberMe: false,
            appCode: userInfo?.moreInfo?.appCode,
        };
        const response = this._service.getTokenOfSwitchApp(payload);
        return response;
    }

    /**
     * Track by function for ngFor loops
     *
     * @param index
     * @param item
     */
    trackByFn(index: number, item: any): any {
        return item.id || index;
    }
}
